import Vue from "vue";
import VueRouter from "vue-router";
import GlobalGuards from "@/guards/Global";
import label from "@/lang/StaticLabels.js";

import TheContainer from "@/containers/TheContainer";
const Page404 = () => import("@/views/errors/Page404");
const Page403 = () => import("@/views/errors/Page403");
const Page500 = () => import("@/views/errors/Page500");
const PageUnderConstruction = () =>
  import("@/views/errors/PageUnderConstruction");

import PBASE from "./modules/pbase.js";
import PACNT from "./modules/pacnt.js";
import PBANK from "./modules/pbank.js";
import PMRP from "./modules/pmrp.js";
import PMRPAL from "./modules/pmrpAl.js";
import PMRPVALVS from "./modules/pmrpValvs.js";
import PHAMYAR from "./modules/phamyar.js";
import PHAMSAZ from "./modules/phamsaz.js";
import PSALE from "./modules/psale.js";
import PWHRS from "./modules/pwhrs.js";
import PSCMS from "./modules/pscms.js";
import PCRM from "./modules/pcrm.js";
import PSTORE from "./modules/pstore.js";
import PMKT from "./modules/pmkt.js";
import PPARAK from "./modules/pparak.js";
import PTAX from "./modules/ptax.js";
import PORDR from "./modules/pordr.js";
import PSLRY from "./modules/pslry.js";
import PPARSINA from "./modules/pparsina.js";
import PDEV from "./modules/pdev.js";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Container",
    component: TheContainer,
    redirect: "/PBASE/Dashboard",
    children: [
      // Other and Common pages
      {
        path: "profile",
        name: "Profile",
        meta: {
          label: label.page.profile,
          requiresAuth: true,
        },
        component: () => import("@/views/auth/Profile"),
      },
      {
        path: "about",
        name: "About",
        meta: {
          label: label.page.aboutUs,
          requiresAuth: false,
        },
        component: () => import("@/views/pages/AboutView"),
      },

      {
        path: "addApiKey",
        name: "AddApiKey",
        meta: {
          label: label.page.apiKeyes,
          requiresAuth: true,
        },
        component: () => import("@/views/pages/ApiKey"),
      },

      // Modules router
      PBASE,
      PACNT,
      PBANK,
      PMRP,
      PMRPAL,
      PMRPVALVS,
      PHAMYAR,
      PHAMSAZ,
      PSALE,
      PWHRS,
      PSCMS,
      PCRM,
      PSTORE,
      PMKT,
      PPARAK,
      PTAX,
      PORDR,
      PSLRY,
      PPARSINA,
      PDEV,

      // ماژولی که سازمان کاربر آن را خریداری نکرده است.
      // داخل Container تعریٝ شده تا هدر و منوی کناری سر جای خود بمانند.
      {
        // پارامتر اختیاری است تا تب هدر که بدون params پوش می‌کند خطا ندهد
        path: "moduleLocked/:subSystemId?",
        name: "ModuleLocked",
        meta: {
          label: label.page.noAccess,
          requiresAuth: true,
        },
        component: () => import("@/views/errors/PageModuleLocked"),
      },

      // Error pages with container
      {
        path: "rejected",
        name: "RejectedTemplate",
        meta: {
          label: label.page.noAccess,
          requiresAuth: false,
        },
        component: () => import("@/views/errors/RejectedTemplate"),
      },
      {
        path: "pages",
        redirect: "pages/404",
        name: "Pages",
        meta: {
          label: label.page.noAccess,
          requiresAuth: false,
        },
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "404",
            name: "Page404",
            meta: {
              label: label.page.noAccess,
              requiresAuth: false,
            },
            component: Page404,
          },
          {
            path: "403",
            name: "Page403",
            meta: {
              label: label.page.noAccess,
              requiresAuth: false,
            },
            component: Page403,
          },
          {
            path: "500",
            name: "Page500",
            meta: {
              label: label.page.noAccess,
              requiresAuth: false,
            },
            component: Page500,
          },
          {
            path: "underConstruction",
            name: "PageUnderConstruction",
            meta: {
              label: label.page.noAccess,
              requiresAuth: false,
            },
            component: PageUnderConstruction,
          },
        ],
      },
    ],
  },
  // end of main container

  // Error page without container
  {
    path: "*",
    component: Page404,
  },

  // other Pages - without container
  {
    path: "/modules",
    name: "Modules",
    meta: {
      label: label.page.modules,
      requiresAuth: true,
    },
    component: () => import("@/views/pages/Modules"),
  },

  {
    path: "/login/:clientId?",
    name: "Login",
    meta: {
      label: label.page.login,
    },
    component: () => import("@/views/auth/Login"),
    beforeEnter(to, from, next) {
      GlobalGuards.login(to, from, next);
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: () => ({
    behavior: "smooth",
    y: 0,
    x: 0,
  }),
  routes,
});

router.beforeEach((to, from, next) => GlobalGuards.beforeEach(to, from, next));
router.afterEach((to, from) => GlobalGuards.afterEach(to, from));

export default router;
